export const AgentProfileFilterKey = {
  Type: 'type',
  Region: 'region',
  Department: 'department',
} as const;
export type AgentProfileFilterKey = (typeof AgentProfileFilterKey)[keyof typeof AgentProfileFilterKey];
export const AGENT_PROFILE_FILTER_KEYS = [
  AgentProfileFilterKey.Type,
  AgentProfileFilterKey.Region,
  AgentProfileFilterKey.Department,
] as const;
